var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "../../UI/Icon/Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("../../UI/Icon/Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Icon);
    global.TeaserEventInfos = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _Icon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _Icon = _interopRequireDefault(_Icon);

  var TeaserEventInfos = function TeaserEventInfos(_ref) {
    var location = _ref.location,
        dateEvent = _ref.dateEvent,
        linkInfo = _ref.linkInfo,
        linkTerms = _ref.linkTerms;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "club-event-infos"
    }, location && /*#__PURE__*/_react.default.createElement("div", {
      className: "club-event-infos__entry"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: "club-event-infos__icon",
      size: "small",
      name: "arte-next-map-marker"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "club-event-infos__label"
    }, location)), dateEvent && /*#__PURE__*/_react.default.createElement("div", {
      className: "club-event-infos__entry"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: "club-event-infos__icon",
      size: "small",
      name: "arte-next-calendar"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "club-event-infos__label"
    }, dateEvent)), linkInfo && /*#__PURE__*/_react.default.createElement("div", {
      className: "club-event-infos__entry"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "club-event-infos__link next-color--arte underlined",
      href: linkInfo.url
    }, linkInfo.label)), linkTerms && /*#__PURE__*/_react.default.createElement("div", {
      className: "club-event-infos__entry"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "club-event-infos__link next-color--arte underlined",
      href: linkTerms.url
    }, linkTerms.label)));
  };

  TeaserEventInfos.propTypes = {
    location: _propTypes.default.string.isRequired,
    dateEvent: _propTypes.default.string.isRequired,
    linkInfo: _propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    }),
    linkTerms: _propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    })
  };
  TeaserEventInfos.defaultProps = {
    location: '',
    dateEvent: '',
    linkInfo: null,
    linkTerms: null
  };
  var _default = TeaserEventInfos;
  _exports.default = _default;
});